export default function CommandIcon({ name, className = '' }) {
  return <img src={`/command-icons/${name}.svg`} alt="" aria-hidden="true" className={`command-icon ${className}`} draggable="false" />;
}
